import { Box, Typography, useTheme } from '@mui/material';
import { t } from 'i18next';
import { useAppSelector } from '../../../app/hooks';
import { selectNumAPIItems } from '../apiExplorerSlice';

const APIRawAndFilteredCountDisplay: React.FC = () => {
  const theme = useTheme();
  const { total, filtered } = useAppSelector(selectNumAPIItems);

  return (
    <Box>
      <Typography variant='h6'>
        <span style={{ color: theme.colors.common.bloomfieldGreen }}>
          {filtered}
        </span>
        {` / ${total} `}
        {`${t('Total', { ns: 'common' })} `}
      </Typography>
    </Box>
  );
};
export default APIRawAndFilteredCountDisplay;
